export default "__VITE_ASSET__5e514464__"